import React from 'react';
import { get } from 'lodash';
import BaseFiltroAvancadoListaItem from '../../base/BaseFiltroAvancadoListaItem'
import { formatDate } from '../../utils';

class FiltroAvancadoItens extends BaseFiltroAvancadoListaItem {
  handleSubmit = () => {
    const { buscarItens } = this.props;
    const { values } = this.formApi.getState();
    this.toggle();

    var changePageFilter = {};
    for (var prop in this.state.valueFilterselectBase) {
      changePageFilter[prop] = this.state.valueFilterselectBase[prop];
    };
    for (var prop in values) {
      changePageFilter[prop] = values[prop];
    };

    buscarItens(this.getValues(changePageFilter));

    this.updateFilterBoxes(changePageFilter);
    this.setState({ valueFilterselect: changePageFilter })
  };

  removeFilter() {
    const { filterToRemove, buscarItens } = this.props;
    const newValues = { ...this.values };
    delete newValues[filterToRemove];
    this.values = newValues;
    buscarItens(this.values);

    var changePageFilter = {};
    for (var prop in this.state.valueFilterselectBase) {
      if (prop === filterToRemove) {
        changePageFilter[prop] = "";
        if (prop === "habilidade") {
          this.setState({ valueHabilidade: "" });
        } else if (prop === "periodo") {
          this.setState({ valuePeriodo: "" });
        } else if (prop === "componente_curricular") {
          this.setState({ valueComponenteCuricular: "" });
        } else if (prop === "curso") {
          this.setState({ valueCurso: "" });
        }
      } else if (
        prop === "habilidade" &&
        changePageFilter.matriz_referencia === ""
      ) {
        this.setState({ valueHabilidade: "" });
        changePageFilter[prop] = "";
      } else if (prop !== filterToRemove) {
        changePageFilter[prop] = this.state.valueFilterselectBase[prop];
      };
    };

    this.setState({ valueFilterselect: changePageFilter, valueFilterselectBase: changePageFilter })
    this.updateFilterBoxes(changePageFilter);
  }

  componentDidUpdate() {
    const { filterToRemove, filterClick } = this.props;

    const shouldRemoveFilter = filterToRemove && filterClick;
    if (shouldRemoveFilter) {
      this.removeFilter();
    }
  }

  updateFilterBoxes = (values) => {
    const { updateFilterBoxes } = this.props;
    const labels = {
      criado_por: 'elaborador',
      tipo: 'tipo de objeto de aprendizado',
      status: 'status',
      exame: 'exame',
      dificuldade: 'dificuldade',
      mochila: 'mochila',
      topico: 'topico',
      subtopico: 'subtopico',
      area_conhecimento: 'área do conhecimento',
      competencia: 'competência',
      habilidade: 'habilidade',
      encomenda: 'encomenda',
      matriz_referencia: 'matriz de referência',
      nunca_utilizados: 'nunca utilizados',
      enunciado: 'enunciado',
      alternativa: 'alternativa',
      palavras_chave: 'palavras-chave',
      min_bisserial: 'min. bisserial',
      max_bisserial: 'max. bisserial',
      min_discriminacao: 'min. discriminação',
      max_discriminacao: 'max. discriminação',
      min_dificuldade: 'min. dificuldade',
      max_dificuldade: 'max. dificuldade',
      min_pa: 'min. A',
      max_pa: 'max. A',
      min_pb: 'min. B',
      max_pb: 'max. B',
      min_pc: 'min. C',
      max_pc: 'max. C',
      min_criado_em: 'min. data de criação',
      max_criado_em: 'max. data de criação',
      id: 'código',
      periodo: 'periodo',
      componente_curricular: 'componente curricular',
      external_id: "external id",
      curso: "segmento/etapa",
      publico: "publico",
    };
    const fieldsWithOptions = [
      'criado_por',
      'tipo',
      'status',
      'exame',
      'dificuldade',
      'area_conhecimento',
    ];
    const fieldsWithAsyncOptions = [
      'competencia',
      'encomenda',
      'matriz_referencia',
    ];
    const multi = [
      'palavras_chave',
    ];
    const dates = [
      'min_criado_em',
      'max_criado_em',
    ];
    const bools = [
      'nunca_utilizados',
      "publico",
    ];
    const boxes = Object.entries(values).map((entry) => {
      const field = entry[0];
      const value = entry[1];

      const box = { field, label: labels[field] };
      const hasOptions = fieldsWithOptions.find(d => d === field);
      const hasAsyncOptions = fieldsWithAsyncOptions.find(d => d === field);
      const isMulti = multi.find(d => d === field);
      const isDate = dates.find(d => d === field);
      const isBool = bools.find(d => d === field);
      if (hasOptions) {
        box.value = get(this.state, field).find(d => +d.value === +value) && get(this.state, field).find(d => +d.value === +value).label;
      } else if (hasAsyncOptions) {
        if (field === "matriz_referencia") {
          box.value = value;
          box.valueLabel = this.state.valueMatrizReferencia;
        } else {
          box.value = get(value, 'label');
        }
      } else if (isMulti) {
        box.value = value.map(d => d.label).join(', ');
      } else if (isDate) {
        box.value = formatDate(value);
      } else if (isBool) {
        if (value) {
          box.value = <i className="fas fa-check-circle" />;
        }
      } else if (field === "habilidade") {
        box.value = value;
        box.valueLabel = this.state.valueHabilidade;
      } else if (field === "periodo") {
        box.value = this.state.valuePeriodo;
      } else if (field === "componente_curricular") {
        box.value = this.state.valueComponenteCuricular;
      } else if (field === "curso") {
        box.value = value;
        box.valueLabel = this.state.valueCurso;
      } else {
        box.value = value;
      }
      return box;
    });

    const boxesWithValidValues = boxes.filter(d => d.value);
    updateFilterBoxes(boxesWithValidValues);
  };

  renderFooter() {
    return (
      <React.Fragment>
        <button style={{ marginTop: '10px', borderRadius: "70px", background: "#E4E4E4", boxShadow: "2px 2px 7px rgba(0, 0, 0, 0.25)", color: "#878787", padding: "5px 20px", marginRight: '26px' }} className="btn danger-button mr-3" type="button" onClick={this.toggle}>Fechar</button>
        <button style={{ marginTop: '10px', borderRadius: "70px", boxShadow: "2px 2px 7px rgba(0, 0, 0, 0.25)", padding: "5px 20px" }} className="btn primary-button mr-1" type="button" onClick={this.handleSubmit}>Buscar</button>
      </React.Fragment>
    );
  }
}

export default FiltroAvancadoItens;
